import { Injectable } from '@angular/core';
import { GetPredictionParams, GetPredictionsParams } from '../holding-utils';
@Injectable({
  providedIn: 'root',
})
export class PredictionsService {
  getPredictionsAndMinMax(params: GetPredictionsParams, target: boolean, loan: boolean) {
    const {
      esopPercentage,
      esopType,
      holdingBeforeRoundPercentage,
      investments,
      preMoney,
      rounds,
      targetHolding,
      totalConvertibles,
      discounts,
      fundsLoan
    } = params;
    let min = 0;
    let max = 0;
    const predictionsMatrix: number[][] = [];
    for (const investment of investments) {
      const row: number[] = [];

      for (const [i, round] of rounds.entries()) {
        const getPredictionParams: GetPredictionParams = {
          esopPercentage,
          esopType,
          holdingBeforeRoundPercentage,
          investment,
          preMoney,
          round,
          targetHolding,
          totalConvertibles,
          discount: discounts[i],
          fundsLoan
        };
        let prediction = 0;
        if (target && loan) {
          prediction = this.getTargetPredictionWithLoan(getPredictionParams)
        } else if(!target && loan) {
          prediction =  this.getPredictionWithLoan(getPredictionParams)
        } else if (target && !loan){
          prediction = this.getTargetPredictionWithoutLoan(getPredictionParams)
        } else if (!target && !loan){
          prediction = this.getPredictionWithoutLoan(getPredictionParams)
        }
        if (min === 0) min = prediction;
        if (prediction < min) min = prediction;
        if (prediction > max) max = prediction;

        row.push(prediction);
      }

      predictionsMatrix.push(row);
    }

    return { predictionsMatrix, min, max };
  }

  private getTargetPredictionWithLoan(p: GetPredictionParams) {
    return (p.targetHolding - (p.holdingBeforeRoundPercentage * (p.round- (p.esopPercentage * (p.round + p.investment)) - p.totalConvertibles/p.discount) + p.fundsLoan/p.discount)/(p.round + p.investment)) * (p.round + p.investment)
  }

  private getTargetPredictionWithoutLoan(p: GetPredictionParams) {
    return (p.targetHolding - (p.holdingBeforeRoundPercentage * (p.round - (p.esopPercentage * (p.round + p.investment))) + p.fundsLoan)/(p.round + p.investment)) * (p.round + p.investment)
  }

  private getPredictionWithLoan(p: GetPredictionParams) {
    return ((p.holdingBeforeRoundPercentage * (p.preMoney - (p.esopPercentage * (p.preMoney + p.round)) - p.totalConvertibles/p.discount) + p.fundsLoan/p.discount)/(p.preMoney + p.round)) + p.investment /(p.preMoney + p.round)
  }

  private getPredictionWithoutLoan(p: GetPredictionParams) {
    return ((p.holdingBeforeRoundPercentage * (p.preMoney - (p.esopPercentage * (p.preMoney + p.round))) + p.fundsLoan)/(p.preMoney + p.round)) + p.investment /(p.preMoney + p.round)
  }
}

